"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPageDelegate = addPageDelegate;
exports.startPageLifecycle = startPageLifecycle;

var _pageVisibility = require("./utilities/pageVisibility");

var hidden = (0, _pageVisibility.getHiddenPropName)();
var visibilityChange = (0, _pageVisibility.getVisibilityChangeEventName)();
var delegates = []; // Keep track of whether the page will be terminated.

var isUnloading = false;

function pageDidLoad() {
  delegates.forEach(function (delegate) {
    if (typeof delegate.pageDidLoad === 'function') {
      delegate.pageDidLoad.call(delegate);
    }
  });
}

function pageDidAppear() {
  delegates.forEach(function (delegate) {
    if (typeof delegate.pageDidAppear === 'function') {
      delegate.pageDidAppear.call(delegate);
    }
  });
}

function pageDidDisappear(message) {
  delegates.forEach(function (delegate) {
    if (typeof delegate.pageDidDisappear === 'function') {
      delegate.pageDidDisappear.call(delegate, message);
    }
  });
}

function pageVisibilityDidChange(event) {
  if (hidden != null) {
    if (document[hidden]) {
      pageDidDisappear({
        timeStamp: event.timeStamp,
        unloading: isUnloading
      });
    } else {
      pageDidAppear();
    }
  }
}

function pageDidHide(event) {
  if (!event.persisted) {
    isUnloading = true;
  }
} // Needed to fix this bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=987409
// Unfortunately, this will also disable BF cache for Firefox and Webkit browsers.


function pageWillUnload() {
  delegates.forEach(function (delegate) {
    if (typeof delegate.pageWillUnload === 'function') {
      delegate.pageWillUnload.call(delegate);
    }
  });
}

function addPageDelegate(delegate) {
  delegates.push(delegate);
}

function startPageLifecycle() {
  if (document.readyState === 'complete') {
    pageDidLoad(); // Use `pageshow` if available since it will fire even if page came from
    // a back-forward page cache. Browsers that support `pageshow` will not
    // fire `onload` if navigation was through a back/forward button and
    // the page was retrieved from back-forward cache.
  } else if ('onpagehide' in window) {
    window.addEventListener('pageshow', pageDidLoad, false);
  } else {
    window.addEventListener('load', pageDidLoad, false);
  }

  window.addEventListener('pagehide', pageDidHide, true);

  if (visibilityChange != null) {
    window.addEventListener(visibilityChange, pageVisibilityDidChange, true);
  }

  window.addEventListener('unload', pageWillUnload, true);
}